
import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
export default function transparent(props:any) {
    return (
        <>            
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 24.75V14.25L19.8447 19.5V30L13 24.75Z" fill="#DBDADA"/>
            <path d="M19.8447 19.5L26.6894 14.25V24.75L19.8447 30V19.5Z" fill="#ACAAAA"/>
            <path d="M19.8447 9L13 14.25L19.8447 19.5L26.6894 14.25L19.8447 9Z" fill="white"/>
            <path d="M20.0808 19.5L20 30" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.0808 9L20 19.5" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 24.75L19.8447 19.5L26.6894 24.75" stroke="black" stroke-width="0.5"/>
            <path d="M27 24.334V14.666C27 14.5213 26.9714 14.3792 26.9171 14.2542C26.8627 14.1293 26.7847 14.0259 26.6908 13.9547L20.2995 9.10576C20.2081 9.03643 20.105 9 20 9C19.895 9 19.7919 9.03643 19.7005 9.10576L13.3092 13.9547C13.2153 14.0259 13.1373 14.1293 13.0829 14.2542C13.0286 14.3792 13 14.5213 13 14.666V24.334C13 24.4787 13.0286 24.6208 13.0829 24.7458C13.1373 24.8707 13.2153 24.9741 13.3092 25.0453L19.7005 29.8942C19.7919 29.9636 19.895 30 20 30C20.105 30 20.2081 29.9636 20.2995 29.8942L26.6908 25.0453C26.7847 24.9741 26.8627 24.8707 26.9171 24.7458C26.9714 24.6208 27 24.4787 27 24.334V24.334Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M26.9167 14.2536L20.0809 19.5003L13.084 14.2524" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        </>
    )
}

